export default __webpack_public_path__ + "static/media/cf3ee0ca-02a1-439a-bede-68c8729ff9be.9dc97346.png";